import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import Select from 'react-select';
import ChangeForm from './AgentUpdateForms';
import ManagementCommercial from './RZmenu/RZManagement';
import AdminAreaSelect from './AdminAreaSelect';

import { getZoneList } from '../../../../../../jsx/reducers/paygAdmin/zones';
import Dialog from '../../../commonModules/interface/Dialog';
import PinDropIcon from '@material-ui/icons/PinDrop';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import RefreshIcon from '@material-ui/icons/Refresh';
import TabletMacIcon from '@material-ui/icons/TabletMac';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { AddCircleOutline } from '@material-ui/icons';
import { blue, indigo, teal } from '@material-ui/core/colors';
import CardButton from '../../../commonModules/interface/CardButton';
import WcIcon from '@material-ui/icons/Wc';

const listStatus = [
    {label: "Actif ", value: "active"},
    {label: "Bloqué", value: "blocked"},
    {label: "Indisponible", value: "unavailable"},
    {label: "Nommé responsable de zone", value: "addRZ"},
    {label: "Supprimé status responsable de zone", value: "removeRZ"},
];

// Valeurs attendues par domainModel (.../agent/update/gender) ; "" = non renseigné.
const GENDER_OPTIONS = [
    { label: "—", value: "" },
    { label: "Homme", value: "Male" },
    { label: "Femme", value: "Female" },
];

/**
 * Genre d'un agent tel que le renvoie le listing des agents. domainModel (ListAllAgentHandlerV1_1)
 * le place sous la clé `type` ; typeperson / typePerson restent lus en repli. Seules les
 * valeurs exactes Male / Female sont retenues (casse stricte côté backend). Nom de champ
 * à ajuster ici seulement.
 */
function agentGender(agent) {
    const candidates = [agent.type, agent.typeperson, agent.typePerson];
    for (let i = 0; i < candidates.length; i++) {
        if (candidates[i] === "Male" || candidates[i] === "Female") return candidates[i];
    }
    return "";
}

class ChangeStatusForm extends Component {
    render () {
        return (
            <div>
                {/* <Select
                    options={listStatus}
                    className="form-control"
                    name="newStatus"
                    value={this.props.statusDisplay}
                    placeholder="Choisissez un Statut"
                    onChange={ this.props.handleSelect }
                    style={{border: '0'}}
                    // selectedValue={this.state.status}
                /> */}
                <InputSelect
                    options={listStatus}
                    className="form-control"
                    name="newStatus"
                    value={this.props.newStatus}
                    placeholder="Choisissez un Statut"
                    onChange={ this.props.handleSelect }
                    style={{border: '0'}}
                    // selectedValue={this.state.status}
                />
            </div>
        )
    } 
}
    
class ChangeZoneForm extends Component {
    render () {
        let listZone = [];
        this.props.listZone.map((zone)=>(
            listZone.push({label: zone.zone_name, value: zone.zone_id})
            ))    
        return (
            <div>
                <InputSelect
                    options={listZone}
                    className="form-control"
                    name="newZone"
                    value={this.props.newZone}
                    placeholder="Choisissez une Zone"
                    onChange={ this.props.handleSelect }
                    style={{border: '0',overflow: 'auto'}}
                    // selectedValue={this.state.status}
                />
                {/* <Select
                    options={listZone}
                    className="form-control"
                    name="newZone"
                    value={this.props.zoneDisplay}
                    placeholder="Choisissez une Zone"
                    onChange={ this.props.handleSelect }
                    style={{border: '0',overflow: 'auto'}}
                    // selectedValue={this.state.status}
                /> */}
            </div>
        )
    }
} 
    
class NewIDForm extends Component {
    render () {
        return (
            <div>
                <InputText name="newAgentID" title="AgentID" value={this.props.newAgentID} change={this.props.handleChange} />
            </div>
        )
    }
} 


class AgentOptions extends Component {
    state = { 
        form: "",
        formTitle: "",
        newAgentID: "",
        newStatus: "",
        statusDisplay: {value:"", label:""},
        newZone: "",
        listAgent: [],
        locationArea1: "",
        locationArea2: "",
        locationError: "",
        gender: "",
        genderError: "",
        zoneDisplay: {value:"", label:""},
        listZone : [
            {label: "Zone 1 ", value: "zone_1"},
        ]
    }
    handleChange = (e) => {
        const { name, value } = e.target;  
        this.setState({
            [name]: value
        })
    }
    handleListChange = (e) =>{
        this.setState({
            listAgent: e,
        })
    }
    openLocationForm = () => {
        // Pré-remplissage depuis le listing des agents (locationArea1/2).
        const agent = (this.props.listAgent && this.props.listAgent[this.props.userID]) || {};
        this.setState({
            formTitle: "Zone du point de vente",
            form: "location",
            locationArea1: agent.locationArea1 || "",
            locationArea2: agent.locationArea2 || "",
            locationError: "",
        });
    }
    handleLocationSubmit = async () => {
        const { locationArea1, locationArea2 } = this.state;
        try {
            const response = await fetch("/agent/update/location", {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ agentID: this.props.userID, locationArea1, locationArea2 }),
                credentials: 'same-origin'
            });
            let resp = {};
            try { resp = await response.json(); } catch (e) { /* corps vide */ }
            // Un rôle sans droit reçoit 404 « No Access » (middleware domainModel), pas 403.
            const noAccess = response.status === 403
                || (response.status === 404 && /no access/i.test(String(resp.error || "")));
            if (noAccess) {
                this.setState({ locationError: "Votre rôle ne permet pas de modifier la zone (page Agents administrateur requise)" });
                return;
            }
            if (response.ok && resp.content === "OK") {
                this.props.close();
                return;
            }
            if (response.status === 404) {
                this.setState({ locationError: "Agent géré par un autre compte : zone non modifiable ici" });
                return;
            }
            this.setState({ locationError: resp.error || "Enregistrement de la zone impossible" });
        } catch (err) {
            console.log("[ERROR], updating location", err);
            this.setState({ locationError: "Enregistrement de la zone impossible" });
        }
    }
    openGenderForm = () => {
        const agent = (this.props.listAgent && this.props.listAgent[this.props.userID]) || {};
        this.setState({
            formTitle: "Genre de l'agent",
            form: "gender",
            gender: agentGender(agent),
            genderInitial: agentGender(agent),
            genderError: "",
        });
    }
    // Mêmes cas d'erreur que la zone : 404 « No Access » (rôle), 404 agent hors compte, 400 valeur.
    handleGenderSubmit = async () => {
        // Sélection inchangée : rien n'est envoyé (une valeur stockée hors liste, « male » par
        // exemple, s'affiche « — » et serait sinon effacée par un simple Valider).
        if (this.state.gender === this.state.genderInitial) {
            this.props.close();
            return;
        }
        try {
            const response = await fetch("/agent/update/gender", {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ agentID: this.props.userID, gender: this.state.gender }),
                credentials: 'same-origin'
            });
            let resp = {};
            try { resp = await response.json(); } catch (e) { /* corps vide */ }
            const noAccess = response.status === 403
                || (response.status === 404 && /no access/i.test(String(resp.error || "")));
            if (noAccess) {
                this.setState({ genderError: "Votre rôle ne permet pas de modifier le genre (page Agents administrateur requise)" });
                return;
            }
            if (response.ok && resp.content === "OK") {
                this.props.close();
                return;
            }
            if (response.status === 404) {
                this.setState({ genderError: "Agent géré par un autre compte : genre non modifiable ici" });
                return;
            }
            if (response.status === 400) {
                this.setState({ genderError: resp.error || "Valeur de genre refusée" });
                return;
            }
            this.setState({ genderError: resp.error || "Enregistrement du genre impossible" });
        } catch (err) {
            console.log("[ERROR], updating gender", err);
            this.setState({ genderError: "Enregistrement du genre impossible" });
        }
    }
    componentDidMount = () => {
        if (this.props.ZONE === ""){
            this.props.getZones()
        }
    }
    // handleSelect = (option) => {
        
    //     this.setState({
    //         [name]: option,
    //         [`${name}Display`]: option.value
    //     })
    // }

    handleSubmit = () => {
        const { form } = this.state;
        if( form === "location" ){
            this.handleLocationSubmit()
            return
        }
        if( form === "gender" ){
            this.handleGenderSubmit()
            return
        }
        let url = ""
        let data = {}
        let valid = false
        data.agentID = this.props.userID
        
        if( this.state.newStatus && form === "status" ){
            url = "/agent/update/status"
            data.newStatus = this.state.newStatus
            valid = true
        } else if( this.state.newZone && form === "zone" ){
            url = "/agent/zone/attribute"
            data.newZone = this.state.newZone
            valid = true
        } else if( this.state.newAgentID && form === "newID" ){
            url = "/agent/update/ID"
            data.newID = this.state.newAgentID
            valid = true
        } else if( form === "rzManagement" ){
            url = "/agent/update/rzmanagement"
            data.listAgent = this.state.listAgent
            valid = true
        }
        console.log('====================================');
        console.log("AGENT OPTIONS Send to ", {valid, url, data});
        console.log('====================================');
        this.handleAct(url, data)
    }
    handleAct = async (url,data) => {
        //Change FORMS
        console.log("Update Info for ",url, " with ",data)
        try {
            const response = await fetch(url, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body:JSON.stringify(data),
              credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response from update: , ");            
            console.log(resp);
            if (resp.content === "OK") {
                this.props.close()
                return;
            }
            console.log("[ERROR], response ", resp)

          } catch (err) {
            console.log("[ERROR], getting response", err)
          }
    }
    render() {
        const { ZONE } = this.props;
        this.state.listZone = ZONE;
        const { form, formTitle } = this.state;
        console.log('====================================');
        console.log("[STATE] AgentOptions render", this.state);
        console.log('====================================');
        return (
            <Dialog 
                title="Options"
                block={true}
                close={this.props.close}
            >
                {form === "updateFORMS" &&
                    <ChangeForm {...this.state} userID={this.props.userID} cancel={() => this.setState({form : "", formTitle: ""})}/>
                }
                {form && form !== "updateFORMS" &&
                    <Dialog
                        title={ formTitle }
                        block={true}
                        close={() => this.setState({form: "", formTitle: ""}) }
                        submitAction={this.handleSubmit}
                    >
                        {form === "status" &&
                            <div>
                                {/* <h4>CHANGE STATUS</h4> */}
                                <ChangeStatusForm {...this.state} 
                                    handleChange={this.handleChange} 
                                    handleSelect={
                                        (option) => this.setState({ statusDisplay: option, newStatus: option.value})
                                    } 
                                />
                                
                            </div>
                        }
                        {form === "zone" &&
                            <div>
                                {/* <h4>Changer la Zone</h4> */}
                                <ChangeZoneForm 
                                    {...this.state} 
                                    handleChange={this.handleChange} 
                                    handleSelect={
                                        (option) => this.setState({ zoneDisplay: option, newZone: option.value})
                                    } 
                                />
                            </div>
                        }
                        {form === "location" &&
                            <div>
                                {this.state.locationError &&
                                    <b style={{color: 'red'}}>{this.state.locationError}</b>
                                }
                                <AdminAreaSelect
                                    agentId={this.props.userID}
                                    area1={this.state.locationArea1}
                                    area2={this.state.locationArea2}
                                    onChange={(a1, a2) => this.setState({ locationArea1: a1, locationArea2: a2, locationError: "" })}
                                />
                            </div>
                        }
                        {form === "gender" &&
                            <div>
                                {this.state.genderError &&
                                    <b style={{color: 'red'}}>{this.state.genderError}</b>
                                }
                                <div style={{ marginTop: 8 }}>
                                    <label htmlFor="agent-gender" style={{ marginRight: 8 }}>Genre</label>
                                    <select
                                        id="agent-gender"
                                        value={this.state.gender}
                                        onChange={(e) => this.setState({ gender: e.target.value, genderError: "" })}
                                        style={{ padding: '6px 8px', fontSize: 14 }}
                                    >
                                        {GENDER_OPTIONS.map((o) => (
                                            <option key={o.value} value={o.value}>{o.label}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        }
                        {form === "newID" &&
                            <div>
                                {/* <h4>Changer l'ID</h4> */}
                                <NewIDForm {...this.state} handleChange={this.handleChange}/>
                            </div>
                        }
                        {form === "rzManagement" &&
                            <div>
                                {/* <h4>Manage Commercial</h4> */}
                                <ManagementCommercial {...this.state} commercialID={this.props.userID} listAgent={this.props.listAgent} handleChange={this.handleListChange}/>
                            </div>
                        }
                        {/* {form === "updateFORMS" &&
                            <div>
                                <h4>Changement Questionnaire</h4>
                                <ChangeForm {...this.state} userID={this.props.userID} cancel={()=> this.setState({form : "", formTitle: ""})}/>
                            </div>
                        } */}
                    </Dialog>
                }                
                <CardButton
                    action={()=> this.setState({formTitle: "Modifier le Statut", form : "status"})}
                    title="Modifier le Statut"
                    icon={<RefreshIcon color="primary" />}
                />
                
                <CardButton 
                    action={()=> this.setState({formTitle: "Attribuer une Zone", form : "zone"})}
                    title="Attribuer une Zone"
                    icon={<PinDropIcon color="error" />}
                /> 

                {this.props.canEditLocation &&
                    <CardButton 
                        action={this.openLocationForm}
                        title="Zone du point de vente"
                        icon={<LocationOnIcon style={{ color: blue[700] }} />}
                    />
                }

                {this.props.canEditLocation &&
                    <CardButton
                        action={this.openGenderForm}
                        title="Genre de l'agent"
                        icon={<WcIcon style={{ color: blue[500] }} />}
                    />
                }
                
                <CardButton 
                    action={()=> this.setState({formTitle: "Créer un ID", form : "newID"})}
                    title="Créer un ID" 
                    icon={<SupervisorAccountIcon style={{ color: teal[500] }} />}
                /> 

                <CardButton 
                    action={()=> this.setState({formTitle: "Changer Questionnaire", form : "updateFORMS"})}
                    title="Changer Questionnaire" 
                    icon={<TabletMacIcon style={{ color: blue[300] }} />}
                /> 

                {this.props.isRZ &&
                    <CardButton 
                        action={()=> this.setState({formTitle: "Lier commerciaux au RZ", form : "rzManagement"})}
                        title="Lier commerciaux au RZ"
                        icon={<AddCircleOutline style={{ color: indigo[300] }} />} 
                    /> 
                }

            </Dialog>
            
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        ZONE: state.zones,
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getZones: getZoneList,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentOptions)
